"use strict";

module.exports = function (
  Member,
  $scope,
  myTenant,
  Tenant,
  gridConfiguration,
  $translate
) {
  var _this = this;
  _this.myTenant = myTenant;
  $scope.showCharts = false;
  $scope.showChartsValidaciones = false;
  $scope.avgMensual = false;
  _this.members = [];
  Member
    .find({
        scope: {
          fields: ["id", "email", "firstName", "lastName"],

        },      
    })
    .$promise
    .then(function (data) {
      _this.members = data;
    });

  function initCalendario() {
    function formatYYYYMMDD(d) {
      return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
    }

    let today = new Date();
    $scope.dateOptions = {
      formatYear: "yyyy",
      startingDay: 1,
    };

    $scope.status = {
      opened: false,
    };
    $scope.openCalendario = function ($event, obj) {
      $scope.status[obj] = true;
    };

    $scope.formats = ["dd-MMMM-yyyy", "yyyy-MM-dd", "dd.MM.yyyy", "shortDate"];
    $scope.format = $scope.formats[1];
    $scope.disabled = function (date, mode) {
      return mode === "day" && (date.getDay() === 0 || date.getDay() === 6);
    };

    $scope.fechaHasta = new Date();
    $scope.fechaDesde = new Date();
    $scope.fechaDesde.setDate($scope.fechaDesde.getDate() - 90);

    $scope.avgMensual = false;

    $scope.chgAvgMensual = function () {
      $scope.avgMensual = !$scope.avgMensual;
    };

    $scope.filtrarRegistros = function () {
      $scope.showCharts = false;
      let fDesde = formatYYYYMMDD($scope.fechaDesde);
      let fHasta = formatYYYYMMDD($scope.fechaHasta);
      try {
        fDesde = document.getElementById("fechaDesde").value;
        fHasta = document.getElementById("fechaHasta").value;
      } catch {
        console.log;
      }
      _this.myTenant.load().then(() => {
        let tenantId = _this.myTenant.get().id;
        Tenant.statistic2({
          //query
          tenantId: tenantId,
          avgMensual: $scope.avgMensual,
          fechaDesde: fDesde,
          fechaHasta: fHasta,
        })
          .$promise.then(function (data) {
            //_this.Tenant = data.response;
            _this.items = data.response;
            _this.gridOptions.api.setRowData(_this.items);
            _this.updChart(
              _this.gridOptions.api.inMemoryRowController.rowsToDisplay
            );
          })
          .catch(function (err) { });
      });
    };
  }

  initCalendario();

  $scope.labels = [];
  $scope.data = [];
  $scope.series = [];
  $scope.chartDatasetOverride = [];

  _this.updChart = function (grupos) {
    $scope.labels = [];
    $scope.data = [];
    $scope.series = [];
    $scope.chartDatasetOverride = [];
    $scope.dataDemora = [];
    $scope.pieChartData = [];
    $scope.pieChartLabelDept = [];
    $scope.pieChartDataDept = [];
    $scope.pieChartLabelForm = [];
    $scope.pieChartDataForm = [];
    let labels = {};
    let series = {};
    let series1 = {};
    let dataTmp = {};
    let dataTmp1 = {};
    let pieChartData = {};
    let deptData = {};
    let formData = {};
    let resp = [];
    grupos.forEach((g) => {
      g.childrenAfterFilter.forEach((i) => {
        resp.push(i);
      });
    });

    resp.forEach((x) => {
      let usuario = x.data.firstName + " " + x.data.lastName;
      series[usuario] = [];
      series1[usuario] = [];
      pieChartData[usuario] = 0;
      labels[x.data.fechaCarga] = null;
      dataTmp[usuario + "." + x.data.fechaCarga] =
        parseFloat(dataTmp[usuario + "." + x.data.fechaCarga] || 0) +
        parseFloat(x.data.cantidad);
      deptData[x.data.deptName] =
        parseFloat(deptData[x.data.deptName] || 0) +
        parseFloat(x.data.cantidad);
      formData[x.data.formName] =
        parseFloat(formData[x.data.formName] || 0) +
        parseFloat(x.data.cantidad);
      let dif = parseFloat(x.data.avgRetardo / 1000 / 60 / 60).toFixed(2);
      if (dif < 0) dif = 0;
      dataTmp1[usuario + "." + x.data.fechaCarga] =
        parseFloat(dataTmp1[usuario + "." + x.data.fechaCarga] || 0) +
        parseFloat(dif * x.data.cantidad);
    });
    Object.keys(labels)
      .sort()
      .reverse()
      .forEach((l) => {
        $scope.labels.push(l);
        Object.keys(series).forEach((s) => {
          if (dataTmp[s + "." + l] != undefined) {
            series[s].push(dataTmp[s + "." + l]);
            pieChartData[s] += dataTmp[s + "." + l];
          } else series[s].push(0);

          if (dataTmp1[s + "." + l] != undefined)
            series1[s].push(dataTmp1[s + "." + l] / dataTmp[s + "." + l]);
          else series1[s].push(0);
        });
      });
    let limite = 0;
    Object.keys(series).forEach((s) => {
      if (limite < 10) {
        $scope.showCharts = true;
        $scope.series.push(s);
        $scope.data.push(series[s]);
        $scope.dataDemora.push(series1[s]);
        $scope.pieChartData.push(pieChartData[s]);
      }
      limite += 1;
    });
    limite = 0;
    Object.keys(deptData).forEach((s) => {
      if (limite < 10) {
        $scope.showCharts = true;
        $scope.pieChartLabelDept.push(s);
        $scope.pieChartDataDept.push(deptData[s]);
      }
      limite += 1;
    });
    limite = 0;
    Object.keys(formData).forEach((s) => {
      if (limite < 10) {
        $scope.showCharts = true;
        $scope.pieChartLabelForm.push(s);
        $scope.pieChartDataForm.push(formData[s]);
      }
      limite += 1;
    });

    $scope.chartOptions = {
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: "right",
        labels: { boxWidth: 2 },
      },
    };
  };
  $scope.filtrarRegistros();

  function getUser(params) {
    if (params.data) {
      return params.data.firstName + " " + params.data.lastName;
    }
    return "";
  }

  // For Validations
  function getValidateUser(params) {
    if (params.data) {
      // console.log('params.data', params.data)
      return params.data.validateDetails_user;
    }
    return "";
  }

  function getDemora(params) {
    if (params.data) {
      let dif = parseFloat(params.data.avgRetardo / 60 / 60 / 1000).toFixed(1);
      if (dif < 0) dif = 0;
      return dif;
    }
    return "N/D";
  }

  _this.columnDefs = [
    {
      headerName: "Departamento",
      field: "deptName",
      colId: "deptName",
    },
    {
      headerName: "Formulario",
      field: "formName",
      colId: "formName",
    },
    {
      headerName: $translate.instant("DASHBOARD.STATS.COLS.EMAIL"),
      field: "email",
      colId: "member-email",
    },
    {
      headerName: $translate.instant("DASHBOARD.STATS.COLS.PERIOD"),
      field: "fechaCarga",
      colId: "member-roles",
      width: 180,
    },
    {
      headerName: $translate.instant("DASHBOARD.STATS.COLS.ITEMS"),
      field: "cantidad",
      filter: "number",
      colId: "member-items",
      width: 110,
    },
    {
      headerName: $translate.instant("DASHBOARD.STATS.COLS.DELAY"),
      valueGetter: getDemora,
      colId: "demoraPromedio",
      width: 110,
      headerTooltip: $translate.instant("DASHBOARD.STATS.COLS.DELAY_TOOLTIP"),
    },
    {
      headerName: $translate.instant("DASHBOARD.STATS.COLS.LAST_ITEM"),
      field: "ultimaFecha",
      sort: "desc",
      cellRenderer: gridConfiguration.timestampRenderer,
      valueGetter: gridConfiguration.timestampGetter2,
      filter: null,
      width: 200,
      comparator: gridConfiguration.dateComparator,
    },
    {
      headerName: "MiembroG",
      rowGroupIndex: 0,
      field: "member",
      hide: true,
      valueGetter: getUser,
      filterParams: { apply: true, newRowsAction: "keep" },
    },
  ];

  // For Validations
  _this.columnDefsValidations = [
    {
      headerName: "Departamento",
      field: "deptName",
      colId: "deptName",
      width: 180,
    },
    {
      headerName: "Formulario",
      field: "formName",
      colId: "formName",
      width: 180,
    },
    {
      headerName: "Email validador",
      field: "validateDetails_email",
      colId: "validateDetails_email",
      width: 180,
      valueGetter: function (params) {
        if (params?.data?.validateDetails_email == "NA" && params.data.validateDetails_userId!="NA")
          return _this.members.find(m=>m.id==params.data.validateDetails_userId)?.email;
        return params?.data?.validateDetails_email;
      },
    },
    {
      headerName: "Fecha",
      field: "fecha",
      colId: "fecha",
    },
    {
      headerName: "OK",
      field: "validate_state_ok",
      colId: "validate_state_ok",
    },
    {
      headerName: "Pendientes",
      field: "validate_state_pending",
      colId: "validate_state_pending",
    },
    {
      headerName: "Rechazados",
      field: "validate_state_reject",
      colId: "validate_state_reject",
    },
    {
      headerName: "UsuarioG",
      rowGroupIndex: 0,
      field: "validateDetails_user",
      hide: true,
      valueGetter: getValidateUser,
      filterParams: { apply: true, newRowsAction: "keep" },
    },
  ];

  function groupAggFunction(rows) {
    let suma = 0;
    let ultimaFecha = "";
    let minPeriodo = "9999-99-99";
    let maxPeriodo = "0000-00-00";
    let demora = 0;
    let deptName = [];
    let formName = [];

    rows.forEach((r) => {
      if (!deptName.includes(r.data.deptName[0]))
        deptName.push(r.data.deptName[0]);
      if (!formName.includes(r.data.formName[0]))
        formName.push(r.data.formName[0]);
      suma += r.data.cantidad;
      demora += r.data.avgRetardo * r.data.cantidad;
      if (ultimaFecha < r.data.ultimaFecha) ultimaFecha = r.data.ultimaFecha;
      if (minPeriodo > r.data.fechaCarga) minPeriodo = r.data.fechaCarga;
      if (maxPeriodo < r.data.fechaCarga) maxPeriodo = r.data.fechaCarga;
    });
    let fila = {
      deptName: deptName,
      formName: formName,
      member: rows[0].parent.key,
      firstName: rows[0].data.firstName,
      lastName: rows[0].data.lastName,
      email: rows[0].data.email,
      fechaCarga: minPeriodo + " / " + maxPeriodo,
      cantidad: suma,
      ultimaFecha: ultimaFecha,
      avgRetardo: parseFloat(demora / suma).toFixed(2),
    };
    return fila;
  }

  // For Validations
  function groupAggFunctionValidations(rows) {
    // console.log('rows', rows);
    let okCant = 0;
    let pendingCant = 0;
    let rejectCant = 0;

    let minPeriodo = "9999-99-99";
    let maxPeriodo = "0000-00-00";

    let deptName = [];
    let formName = [];
    let validateDetails_email = [];

    rows.forEach((r) => {
      if (!deptName.includes(r.data.deptName)) {
        deptName.push(r.data.deptName);
      }
      if (!formName.includes(r.data.formName)) {
        formName.push(r.data.formName);
      }
      // if (!validateDetails_email.includes(r.data.validateDetails_email) && r.data.validateDetails_email !== "NA") {
      //     validateDetails_email.push(r.data.validateDetails_email);
      // }
      if (!validateDetails_email.includes(r.data.validateDetails_email)) {
        validateDetails_email.push(r.data.validateDetails_email);
      }
      if (minPeriodo > r.data.fecha) { minPeriodo = r.data.fecha; }
      if (maxPeriodo < r.data.fecha) { maxPeriodo = r.data.fecha; }

      okCant = okCant + r.data.validate_state_ok;
      pendingCant = pendingCant + r.data.validate_state_pending;
      rejectCant = rejectCant + r.data.validate_state_reject;

    })
    let fila = {
      deptName: deptName,
      formName: formName,
      validateDetails_email: validateDetails_email,
      validateDetails_user: rows[0].parent.key,
      fecha:
        (minPeriodo !== "9999-99-99" ? minPeriodo : '--') + " / " +
        (maxPeriodo !== "0000-00-00" ? maxPeriodo : '--'),
      validate_state_ok: okCant,
      validate_state_pending: pendingCant,
      validate_state_reject: rejectCant
    };
    //   console.log('fila', fila);
    return fila;
  }

  _this.items = [];
  _this.items2 = [];

  _this.downloadCSV = function () {
    _this.gridOptions.api.exportDataAsCsv({
      fileName: _this.myTenant
        .get()
        .name.concat(
          ".",
          document.getElementById("fechaDesde").value,
          ".",
          document.getElementById("fechaHasta").value,
          ".csv"
        ),
    });
  };

//   _this.downloadXLSX = function () {
//     if (_this.gridOptions.api) {
//       var fileName = _this.myTenant
//         .get()
//         .name.concat(
//           ".",
//           document.getElementById("fechaDesde").value,
//           ".",
//           document.getElementById("fechaHasta").value,
//           ".xlsx"
//         );
//       window.exportarAgGridAExcel(_this.gridOptions.api, fileName);
//     }
//   };

  // For Validations
  _this.downloadCSVValidations = function () {
    _this.gridOptionsValidations.api.exportDataAsCsv({
      fileName: _this.myTenant
        .get()
        .name.concat(
          ".",
          document.getElementById("fechaDesde").value,
          ".",
          document.getElementById("fechaHasta").value,
          ".csv"
        ),
    });
  };

  _this.gridOptions = {
    //pageSize: 1000,
    groupIncludeFooter: true,
    groupAggFunction: groupAggFunction,
    groupColumnDef: {
      headerName: $translate.instant("DASHBOARD.STATS.COLS.MEMBER"),
      field: "member",
      valueGetter: getUser,
      filterParams: { apply: true, newRowsAction: "keep" },
      width: 200,
      cellRenderer: {
        renderer: "group",
        footerValueGetter: $translate.instant("DASHBOARD.STATS.COLS.TOTAL"),
        padding: 5,
      },
    },
    debug: false,
    rowBuffer: 0,
    columnDefs: _this.columnDefs,
    enableFilter: true,
    enableColResize: true,
    enableSorting: true,
    forPrint: false,
    rowData: _this.items,
    rowHeight: 40,
    headerHeight: 40,
    angularCompileRows: true,
    angularCompileFilters: true,
    angularCompileHeaders: true,
    localeText: gridConfiguration.localeText,
    onAfterFilterChanged: function () {
      _this.updChart(_this.gridOptions.api.inMemoryRowController.rowsToDisplay);
    },
    components: {
      loadingCellRenderer: function (params) {
        if (params.value !== undefined) {
          return params.value;
        } else {
          return '<img src="https://raw.githubusercontent.com/ag-grid/ag-grid/master/packages/ag-grid-docs/src/images/loading.gif">';
        }
      },
    },
  };

  // For Validations
  _this.gridOptionsValidations = {
    //pageSize: 1000,
    groupIncludeFooter: true,
    groupAggFunction: groupAggFunctionValidations,
    groupColumnDef: {
      // headerName: $translate.instant("DASHBOARD.STATS.COLS.MEMBER"),
      headerName: "Usuario",
      field: "validateDetails_user",
      valueGetter: getValidateUser,
      filterParams: { apply: true, newRowsAction: "keep" },
      width: 200,
      cellRenderer: {
        renderer: "group",
        footerValueGetter: $translate.instant("DASHBOARD.STATS.COLS.TOTAL"),
        padding: 5,
      },
    },
    debug: false,
    rowBuffer: 0,
    columnDefs: _this.columnDefsValidations,
    enableFilter: true,
    enableColResize: true,
    enableSorting: true,
    // forPrint: true,
    forPrint: false,
    rowData: _this.items2,
    rowHeight: 40,
    headerHeight: 40,
    angularCompileRows: true,
    angularCompileFilters: true,
    angularCompileHeaders: true,
    localeText: gridConfiguration.localeText,
    components: {
      loadingCellRenderer: function (params) {
        if (params.value !== undefined) {
          return params.value;
        } else {
          return '<img src="https://raw.githubusercontent.com/ag-grid/ag-grid/master/packages/ag-grid-docs/src/images/loading.gif">';
        }
      },
    },
  };

  _this.graphValidationsConfig = [
    {
      id: "Graph0",
      templateData: {
        data: [],
        showlegend: false,
      },
      partsOfWindowWidth: 2,
      partsOfWindowHeight: 2,
      pivotConfig: {
        cols: ["validate_state"],
        rows: ["deptName", "formName", "itemCreatedAtDate"],
        vals: ["itemId"],
        aggregatorName: "Cuenta de valores únicos",
        rendererName: "Table",
      },
      name: "Validación de Registros por Formularios",
      hideTitleBar: true, exportCSVButton: true
    },
    {
      id: "Graph1",
      templateData: {
        data: [],
        showlegend: false,
      },
      partsOfWindowWidth: 2,
      partsOfWindowHeight: 2,
      pivotConfig: {
        cols: ["validate_state"],
        rows: ["deptName", "formName", "itemCreatedAtDate"],
        vals: ["itemId"],
        aggregatorName: "Cuenta de valores únicos",
        rendererName: "Horizontal Stacked Bar Chart",
      },
      name: "Validación de Registros por Formularios",
      hideTitleBar: true,
    },
    {
      id: "Graph2",
      templateData: {
        data: [],
        showlegend: true,
      },
      partsOfWindowWidth: 2,
      partsOfWindowHeight: 2,
      pivotConfig: {
        cols: ["itemCreatedAtDate"],
        rows: ["validateDetails_user", "validateDetails_state"],
        aggregatorName: "Cuenta",
        rendererName: "Stacked Bar Chart",
      },
      name: "Validación de Registros por Supervisor",
      hideTitleBar: true,
    },
    {
      id: "Graph3",
      templateData: {
        data: [],
        showlegend: true,
      },
      partsOfWindowWidth: 2,
      partsOfWindowHeight: 2,
      pivotConfig: {
        cols: ["itemCreatedAtDate"],
        rows: ["validateDetails_user", "validateDetails_state"],
        aggregatorName: "Cuenta",
        rendererName: "Table",
      },
      name: "Validación de Registros por Supervisor",
      hideTitleBar: true, exportCSVButton: true
    },
    {
      id: "Graph4",
      templateData: {
        data: [],
        showlegend: true,
      },
      partsOfWindowWidth: 2,
      partsOfWindowHeight: 2,
      pivotConfig: {
        cols: ["itemCreatedAtDate"],
        rows: ["validateDetails_user"],
        aggregatorName: "Promedio",
        vals: ["validateDetails_delayHs"],
        rendererName: "Bar Chart",
        exclusions: { validateDetails_user: ["NA"] }
      },
      name: "Validación de Registros por Supervisor",
      hideTitleBar: true,
    },
    {
      id: "Graph5",
      templateData: {
        data: [],
        showlegend: true,
      },
      partsOfWindowWidth: 2,
      partsOfWindowHeight: 2,
      pivotConfig: {
        cols: ["itemCreatedAtDate"],
        rows: ["deptName", "formName"],
        aggregatorName: "Promedio",
        vals: ["validate_delayHs"],
        rendererName: "Bar Chart",
        exclusions: { validate_delayHs: ["NA"] }
      },
      name: "Validación de Registros por Supervisor",
      hideTitleBar: true,
    },
  ];

  _this.getValidationsInfo = () => {
    $scope.showChartsValidaciones = false;
    let fDesde = $scope.fechaDesde;
    let fHasta = $scope.fechaHasta;
    try {
      fDesde = document.getElementById("fechaDesde").value;
      fHasta = document.getElementById("fechaHasta").value;
    } catch {
      console.log;
    }
    _this.myTenant.load().then(() => {
      let tenantId = _this.myTenant.get().id;
      Tenant.statisticValidations({
        //query
        tenantId: tenantId,
        fechaDesde: fDesde,
        fechaHasta: fHasta,
      })
        .$promise.then(function (data) {
          data = data.response;

          // Group items by user, dept, form and date (pending: create, else validate_updatedAt)
          let groupedItems = data.reduce((acc, item) => {
            const key = `${item.validateDetails_user}|${item.departmentId}|${item.formId}|${item.validate_state === 'PENDING' ? item.itemCreatedAtDate : item.validate_updatedAt}`;

            if (!acc[key]) {
              acc[key] = {
                ...item,
                fecha: item.validate_state === 'PENDING' ? item.itemCreatedAtDate : item.validate_updatedAt.split('T')[0],
                validate_state_ok: 0,
                validate_state_pending: 0,
                validate_state_reject: 0,
              };
            }

            if (item.validate_state === 'OK') { acc[key].validate_state_ok++ };
            if (item.validate_state === 'PENDING') { acc[key].validate_state_pending++ };
            if (item.validate_state === 'REJECT') { acc[key].validate_state_reject++ };

            return acc;
          }, {});

        // Convert grouped objetc to a new array
        _this.items2 = Object.values(groupedItems);

          // For Validations
          _this.gridOptionsValidations.api.setRowData([..._this.items2]);

          if (data.length > 0) {
            let periodo = $scope.avgMensual
              ? "itemCreatedAtMonth"
              : "itemCreatedAtDate";
            _this.graphValidationsConfig[0].pivotConfig.rows[2] = periodo;
            _this.graphValidationsConfig[1].pivotConfig.rows[2] = periodo;
            _this.graphValidationsConfig[2].pivotConfig.cols[0] = periodo;
            _this.graphValidationsConfig[3].pivotConfig.cols[0] = periodo;
            _this.graphValidationsConfig[4].pivotConfig.cols[0] = periodo;
            _this.graphValidationsConfig[5].pivotConfig.cols[0] = periodo;
            _this.graphValidationsConfig.forEach((graph) => {
              graph.templateData.data = data;
            });
            $scope.showChartsValidaciones = true;
            $scope.$broadcast("graph-reloadData", false);
          }
        })
        .catch(function (err) { });
    });
  };
  _this.getValidationsInfo();
};
